module.exports = __webpack_public_path__ + "img/grey_cross.69377e5c.svg";